import React from 'react';

import TableCell from '@material-ui/core/TableCell';

import TableRow from '@material-ui/core/TableRow';

import Tooltip from '@material-ui/core/Tooltip';

import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const Item = ({ name, description, weight, quantity, removeItem, addItem }) => {

  return (
    <React.Fragment>
      <TableRow key={name}>
        <TableCell>
          <Tooltip title="Adicionar mais um">
            <IconButton onClick={() => addItem(name)} size="small">
              <AddIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remover item">
            <IconButton onClick={() => removeItem(name)} size="small">
              <RemoveIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell component="th" scope="row">
          {name}
        </TableCell>
        <TableCell>
          {description}
        </TableCell>
        <TableCell>
          {weight}
        </TableCell>
        <TableCell align="right">
          {quantity}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default Item;